module.exports = __webpack_public_path__ + "static/media/editor_screenshot_ru.b259826a.png";